<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

export default {
  name: 'app',
  components: {
  }
}
</script>

<style>
*{
  margin: 0;
  padding: 0;
}
#app {

}
</style>
